import React, { PureComponent } from 'react'
import { Link } from 'react-router-dom'
import { Field, reduxForm } from 'redux-form'
import { TextField } from 'redux-form-material-ui'
import { RaisedButton } from 'material-ui'
import { required } from '../form/validation'
import { themeColors } from '../styles/theme'

const styles = {
  text: {
    marginBottom: 0,
    paddingTop: 30,
    color: themeColors.darkBlack,
  },
  logo: {
    width: '170px',
    height: 'auto',
    marginBottom: '30px',
    marginTop: 10,
  },
  smallText: {
    fontSize: 12,
    color: themeColors.darkBlack,
    paddingBottom: 10,
  },
}

class PasswordRecoverForm extends PureComponent {
  render() {
    const { handleSubmit, submitting } = this.props

    return (
      <form onSubmit={handleSubmit}>
        <p style={styles.text}>Hai dimenticato la Password?</p>
        <div>
          <Field
            name="username"
            component={TextField}
            validate={required}
            hintText="Username"
            floatingLabelText="Username"
          />
        </div>
        <div>
          <RaisedButton
            label="Reimposta Password"
            disabled={submitting}
            type="submit"
            style={{ marginBottom: '10px', marginTop: '10px' }}
            primary={true}
          />
        </div>
        <p style={styles.smallText}>
          Non hai ancora un account?
          {' '}
          <Link to="/register" style={{ color: themeColors.positive }}>
            Registrati
          </Link>
        </p>
      </form>
    )
  }
}

export default reduxForm({
  form: 'password-recover-form',
})(PasswordRecoverForm)



// WEBPACK FOOTER //
// ./src/common/PasswordRecoverForm.js